import React from 'react';

// Cloudflare requires this disclosure wherever the (invisible) Turnstile
// widget runs. Same copy/links as the ticket checkout form.
const TurnstileDisclosure = () => (
  <p className="mb-0 text-muted" style={{ fontSize: '10px', marginTop: '12px' }}>
    This site is protected by Cloudflare Turnstile and the Cloudflare{' '}
    <a target="_blank" rel="noopener noreferrer" href="https://www.cloudflare.com/privacypolicy/">Privacy Policy</a> and{' '}
    <a target="_blank" rel="noopener noreferrer" href="https://www.cloudflare.com/website-terms/">Terms of Service</a> apply.
  </p>
);

export default TurnstileDisclosure;
